import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialCategoryState: ICardMasterData = {
  data: {
    cardMaster: [],
    meta: {},
  },
  deleteSuccess: false,
  sortCardMasterData: [],

  loading: false,
  success: false,
}

export interface ICardMasterData {
  data: {
    cardMaster: any
    meta: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  sortCardMasterData: ICardMasterData[]
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ICardMasterData = initialCategoryState,
  action: ActionWithPayload<ICardMasterData>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_CARD_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_CARD_MASTER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_ALL_CARD_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_SPECIFIC_CARD_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_SPECIFIC_CARD_MASTER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_SPECIFIC_CARD_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.GET_CARD_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_CARD_MASTER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_CARD_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_CARD_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_CARD_MASTER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_CARD_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_CARD_MASTER_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_CARD_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_CARD_MASTER_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_CARD_MASTER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_CARD_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_CARD_MASTER_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_CARD_MASTER_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_CARD_MASTER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_CARD_MASTER_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_CARD_MASTER_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_CARD_MASTER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_CARD_MASTER_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_CARD_MASTER_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_CARD_MASTER_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_CARD_MASTER_SUCCESS: {
      return {
        ...state,
        sortCardMasterData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_CARD_MASTER_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_CARD_MASTER_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortCardMasterData: [],
      }
    }

    default:
      return state
  }
}
